export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-chat-smile-2-fill text-lg text-white"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-900">
                51吃瓜app
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              热门人物吃瓜第一站。专注台北娜娜、莫里秀、玩偶姐姐等一线热门人物，
              提供最新独家爆料和视频合集，200万+吃瓜群众的共同选择。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4">热门人物</h4>
            <ul className="space-y-2.5">
              {['台北娜娜', '莫里秀', '玩偶姐姐', '娱乐圈爆料'].map((item) => (
                <li key={item}>
                  <a
                    href="#index"
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4">内容导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '吃瓜热评', href: '#comments' },
                { label: '精彩视频', href: '#media' },
                { label: '焦点专题', href: '#carousel' },
                { label: '吃瓜排行榜', href: '#ranking' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4">合作与联系</h4>
            <ul className="space-y-2.5">
              <li className="text-sm text-foreground-500">tg@51chigua.app</li>
              <li className="text-sm text-foreground-500">微信: 51chigua_official</li>
              <li>
                <a href="#contact" className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer">
                  投稿爆料入口
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/60 pt-8">
          <div className="mb-4">
            <h4 className="font-heading text-sm font-bold text-foreground-900 mb-3">合作伙伴</h4>
            <div className="flex flex-wrap gap-4">
              <div className="px-4 py-2 bg-background-50 rounded-lg text-xs text-foreground-400">
                合作伙伴招募中
              </div>
              <div className="px-4 py-2 bg-background-50 rounded-lg text-xs text-foreground-400">
                商务合作请联系
              </div>
              <div className="px-4 py-2 bg-background-50 rounded-lg text-xs text-foreground-400">
                更多合作伙伴即将入驻
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2025 51吃瓜app. 热门人物吃瓜第一站. 保留所有权利.
            </p>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/50 text-foreground-500 hover:text-primary-500 cursor-pointer transition-colors">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/50 text-foreground-500 hover:text-primary-500 cursor-pointer transition-colors">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/50 text-foreground-500 hover:text-primary-500 cursor-pointer transition-colors">
                <i className="ri-vidicon-line"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}